import axiosApi, { setHeader } from "api/root.api";

export const updateProject = async (body, token) => {
  const urlEnd = "/scan/editor/project/v1/update";
  setHeader("Authorization", `Bearer ${token}`);
  const response = await axiosApi.post(urlEnd, body);
  const result = response.data;
  return result;
};
